<template>
    <div>
        <div class="col-12 footersite" id="footersite">
            <div class="footer-block footer-block-light">
                <div class="footer-logo">
                    <img src="~@/assets/imgs/logo_dark.png" >
                </div>
                <div class="footer-redes-sociais-container">
                    <a href="https://www.facebook.com/cartoriosdeprotestobr/" target="_blank" >
                        <img @click="go(menu[0][menuItem()])" src="~@/assets/imgs/icons/facebook.svg" width="13px">
                    </a>
                    <a href="https://www.instagram.com/cartprotestobr/" target="_blank" >
                        <img @click="go(menu[0][menuItem()])" src="~@/assets/imgs/icons/instagram.svg" width="20px">
                    </a>
                    <a href="https://www.linkedin.com/company/ieptb-br/" target="_blank" >
                        <img @click="go(menu[0][menuItem()])" src="~@/assets/imgs/icons/linkedin.svg" width="20px">
                    </a>
                    <!-- <a href="https://twitter.com/IeptbPR" target="_blank" >
                        <img @click="go(menu[0][menuItem()])" src="~@/assets/imgs/icons/twitter.svg" width="20px">
                    </a> -->
                </div>
                <!-- <span><strong><a href="https://api.whatsapp.com/send?phone=551135045941" target="_blank">Contato: (11) 3504 5941</a></strong></span> -->
                <span><a>Contato: (11) 3112 0698</a></span>
            </div>
            <div class="footer-block footer-block-dark">
                <div class="row">
                    <div class="col-12 text-center textorodape mt-4">
                        Copyright © 2021 Cartórios de protesto -<br>Instituto de protesto IEPTB
                    </div>
                </div>
                <div class="row"><span>Saiba mais sobre nossa <a class="link" @click="$router.push({ name: 'recuperar-senha' })">Política de Privacidade</a></span></div>
            </div>
        </div>
        
    </div>
</template>
<script>
export default {
    
}
</script>
<style scoped>
.footersite{position:relative !important;height: fit-content !important;text-align: center;font-family: 'Kanit', sans-serif;font-size:10px;line-height:14px;font-weight: 400;letter-spacing:-1%;color: #EEF1F4;padding: 0 !important;}
.footer-block-light{background-color: var(--secondary-color);padding-top: 26px;padding-bottom: 48px;}
.footer-block-dark{background-color: var(--secondary-color);padding-top: 12px;padding-bottom: 25px;}
.footer-logo{margin-bottom: 31px;}
/* .footer-logo img{height: 51px;width: 126px;} */
.footer-redes-sociais-container{display: flex;justify-content: center;margin-bottom: 38px;}
.footer-redes-sociais-container a{height: 30px;width: 30px;}
.footer-redes-sociais-container a img{height: 16px !important;}
.footer-redes-sociais-container a:nth-child(1) img{height: 20px !important;}
.footer-redes-sociais-container a:nth-child(2) img{height: 22px !important;}
.footer-block .row{justify-content: center;margin:0;max-width:100vw;}
.footer-block .row:first-child{margin-bottom: 24px;}
.footer-block .row a{color:white !important;font-weight: bold;text-decoration: underline;}

.footer-block span a,
.footer-block span a:hover{color:white;}
</style>